import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { AbstractControl, FormGroup } from '@angular/forms';
import { IFormComponent } from '../../models/i-form-component';

@Component({
  selector: 'app-finish',
  templateUrl: './finish.component.html',
  styleUrl: './finish.component.scss'
})
export class FinishComponent implements IFormComponent {

  @Input()model!: InitialAssessmentForm;
  @Input()formTypes!: any;
  @Output() formReady = new EventEmitter<FormGroup>();

  @ViewChild('dataProtectionForm') dataProtectionFormComponent?: any;
  @ViewChild('feedbackForm') feedbackFormComponent?: any;

  dataProtectionFormReady = false;
  feedbackFormReady = false;
  dataProtectionForm: FormGroup | null = null;
  feedbackForm: FormGroup | null = null;

  get allComponentsReady(): boolean {
    return this.dataProtectionFormReady && this.feedbackFormReady;
  }

  onDataProtectionFormReady(form: FormGroup): void {
    this.dataProtectionFormReady = true;
    this.dataProtectionForm = form;
    this.formReady.emit(form as FormGroup);
  }

  onFeedbackFormReady(form: FormGroup): void {
    this.feedbackFormReady = true;
    this.feedbackForm = form;
    this.formReady.emit(form as FormGroup);
  }

  isFormValid(): boolean {
    const feedbackFormValid = this.feedbackFormComponent?.feedbackForm.valid ?? true;
    const dataProtectionFormValid = this.dataProtectionFormComponent?.dataProtectionForm.valid ?? true;
    return dataProtectionFormValid && feedbackFormValid;
    
  }

  markFormAsTouched(): void {
    this.dataProtectionFormComponent?.dataProtectionForm?.markAllAsTouched();
    this.feedbackFormComponent?.feedbackForm?.markAllAsTouched();
  }

}
